import { create } from "zustand";
import { AuthUserModel, SessionToken } from "../../models/LoginModel";
import { persist } from "zustand/middleware";
import { customStorage } from "../customStorage";

export interface AuthState {
  token: string | null;
  refreshtoken: string | null;
  login: (data: SessionToken, user: AuthUserModel) => void;
  loginAuth: (isAuthenticated: boolean) => void;
  logout: () => void;
  clearLogin: () => void;
  isLoading: boolean;
  isAuthenticated: boolean;
  user: AuthUserModel | null;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      refreshtoken: null,
      isAuthenticated: false,
      isLoading: false,
      user: null,
      login: ({ token, refreshtoken }, user) => {
       
        set({
          token: token || null,
          refreshtoken: refreshtoken || null,
          isLoading: false,
          user: user,
          isAuthenticated: true, // ✅ Marcar como autenticado aquí también
        });
      },
      loginAuth: (isAuthenticated: boolean) => {
        set({ isAuthenticated });
      },

      logout: () => {
        set({
          token: null,
          refreshtoken: null,
          isAuthenticated: false,
          isLoading: false,
          user: null,
        });
        localStorage.removeItem("auth-storage");
        sessionStorage.removeItem("auth-storage");
      },

      clearLogin: () => {
        localStorage.removeItem("auth-storage");
        sessionStorage.removeItem("auth-storage");
        set({ token: null, refreshtoken: null });
      },
    }),
    {
      name: "auth-storage", // clave en storage
      storage: customStorage,
      partialize: (state) => ({
        token: state.token,
        refreshtoken: state.refreshtoken,
        isAuthenticated: state.isAuthenticated,
        user: state.user,
      }),
    }
  )
);